// extracted by mini-css-extract-plugin
module.exports = {"title":"Documents_title__gzkDk","selects":"Documents_selects__3cpv0"};